import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { OrganisationDto } from '@assetaccountant/api/models/organisation.dto';
import { PackageType } from '@assetaccountant/api/models/package-type';
import { PaymentComponent } from '@assetaccountant/core/components/payment/payment.component';
import { ValidSubmitEvent } from '@assetaccountant/core/directives/forms/valid-submit.directive';
import { AppNavigationService } from '@assetaccountant/core/services/app-navigation.service';
import { OrganisationService } from '@assetaccountant/core/services/organisation.service';
import { SubscriptionService } from '@assetaccountant/core/services/subscription.service';
import { TypedFormBuilder, emptyValue } from '@assetaccountant/core/utils/typed-forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-payment-method-modal',
  templateUrl: './add-payment-method-modal.component.html',
  styleUrls: ['./add-payment-method-modal.component.scss'],
  standalone: false,
})
export class AddPaymentMethodModalComponent implements OnInit {
  @Input() activeOrganisation: OrganisationDto;
  @Input() paymentCallback: () => void;
  @Input() newOrganisation: boolean;
  @Input() startSubscriptionPackageType: PackageType;

  @Output() packageUpdated = new EventEmitter();

  @ViewChild(PaymentComponent) paymentComponent: PaymentComponent;

  form = this.fb.group({
    paymentMethod: '',
    countryId: [emptyValue<number>(), Validators.required],
  });
  loading = true;
  submitting = false;
  successfullyAttached = false;

  constructor(
    public modal: NgbActiveModal,
    private organisationService: OrganisationService,
    private fb: TypedFormBuilder,
    private appNavigationService: AppNavigationService,
    private subscriptionService: SubscriptionService,
  ) {}

  ngOnInit() {
    this.subscriptionService
      .getSubscription(this.appNavigationService.getActiveOrganisationId(true))
      .subscribe(sub => {
        if (sub.hasPaymentMethod) {
          this.loading = false;
        } else {
          this.organisationService
            .createPaymentCustomer(this.appNavigationService.getActiveOrganisationId(true))
            .subscribe(_ => (this.loading = false));
        }
      });
  }

  onSubmit($event: ValidSubmitEvent) {
    this.submitting = true;
    this.paymentComponent.onSubmit($event);
  }

  close() {
    this.paymentCallback();
    this.modal.close();
  }

  paymentFailedToAttach() {
    this.submitting = false;
  }

  paymentSaved() {
    this.loading = true;
    this.organisationService
      .createSubscription(
        this.appNavigationService.getActiveOrganisationId(),
        this.startSubscriptionPackageType,
      )
      .subscribe(() => {
        this.subscriptionService.reset();

        // Refresh subscription
        this.subscriptionService.getSubscription().subscribe();
        this.packageUpdated.emit();

        this.paymentCallback();
        this.submitting = false;

        this.modal.close();
      });
  }
}
